import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOptionKey: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconOptionKey"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 9H9.3125L13.5625 16.5H17V15H14.4375L10.1875 7.5H7V9ZM13.5 7.5V9H17V7.5H13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOptionKey;
